import { FilterType } from './FilterType';

export const globalFilters: readonly FilterType[] = [
  FilterType.DATE_RANGE,
  FilterType.COMPARISON_PERIOD,
  FilterType.COUNTRY,
  FilterType.TERRITORY,
  FilterType.STATE_PROVINCE,
  FilterType.TA,
  FilterType.OTHER_SPECIALTY,
  FilterType.HCP_PROFESSION,
  FilterType.HCP_TYPE_OF_PRACTICE,
  FilterType.TA_INDICATIONS,
  FilterType.PRODUCTS,
  FilterType.TAE_LEVELS,
  FilterType.CLASSIFICATION_LEVELS,
  FilterType.TOPIC,
  FilterType.CONGRESS,
  FilterType.PUBLICATION,
  FilterType.CLINICAL_TRIAL,
  FilterType.SOCIAL_MEDIA,
  FilterType.GUIDELINE,
  FilterType.TRIAL_SPONSOR,
  FilterType.SCIENTIFIC_ORGANIZATION,
  FilterType.VALUE_AND_MOTIVATION,
  FilterType.FAIR_MARKET_VALUE_RATING,
  FilterType.PREFERRED_CHANNEL_RATING,
  FilterType.SOURCE_SYSTEM,
  FilterType.OPTHTALMOLOGY_PERSONAS,
  FilterType.ADOPTION_RATING,
  FilterType.POTENTIAL_RATING,
  FilterType.ROCHE_INTERACTION_LADDER,
  FilterType.SECONDARY_SPECIALTY,
  FilterType.AREA_OF_INTEREST,
  FilterType.HCP_X_TWITTER_ACCOUNT,
  FilterType.HCP_WITH_LINKED_IN_ACCOUNT,
  FilterType.HCP_WITH_BLUESKY_ACCOUNT,
];

export const hcoGlobalFilters: readonly FilterType[] = [
  FilterType.HCO_COUNTRY,
  FilterType.HCO_STATE_PROVINCE,
  FilterType.HCO_TYPE,
  FilterType.HCO_SPECIALTY,
  FilterType.HCO_PRIVATE_PUBLIC_STATUS,
  FilterType.HCO_SOURCE_SYSTEM,
  FilterType.HCO_ACCOUNT_PLANNING_IN_PROGRESS,
  FilterType.HCO_ACCOUNT_PLANNING_COMPLETED,
];

export const globalHcoHcpFilters: readonly FilterType[] = [...globalFilters, ...hcoGlobalFilters];
